import { render, staticRenderFns } from "./ContactSelect.vue?vue&type=template&id=045a7e11&scoped=true&"
import script from "./ContactSelect.vue?vue&type=script&lang=js&"
export * from "./ContactSelect.vue?vue&type=script&lang=js&"
import style0 from "./ContactSelect.vue?vue&type=style&index=0&id=045a7e11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a7e11",
  null
  
)

export default component.exports